var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPanoName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.54,
    height: 13.54,
    viewBox: "0 0 13.54 13.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772",
    transform: "translate(71.704 -345.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14915",
    "data-name": "Path 14915",
    d: "M-63.365,355.315l-2.109.306a.378.378,0,0,1-.418-.419l.305-2.108a1.08,1.08,0,0,1,.3-.611l6.271-6.271c.828-.828,3.357,1.7,2.529,2.53l-6.271,6.271A1.075,1.075,0,0,1-63.365,355.315Z",
    transform: "translate(-2.341 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14916",
    "data-name": "Path 14916",
    d: "M-58.664,351.571v4.3a2.725,2.725,0,0,1-2.725,2.725h-7.089a2.725,2.725,0,0,1-2.725-2.725V348.78a2.725,2.725,0,0,1,2.725-2.725h4.361",
    transform: "translate(0 -0.003)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPanoName);
export default __webpack_public_path__ + "static/media/edit-pano-name.86223add98c44dd7dfc72bffb43457e2.svg";
export { ForwardRef as ReactComponent };